import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex w-full flex-col items-center px-4 py-24 text-center md:px-8">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-600">
        <i className="ri-compass-3-line text-3xl"></i>
      </span>
      <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        页面走丢了
      </h1>
      <p className="mt-3 text-sm text-foreground-500">{location.pathname}</p>
      <p className="mt-4 max-w-md text-sm leading-7 text-foreground-600">
        你访问的页面可能已被移动或删除。可以返回首页，或者去浏览最新的网友投稿。
      </p>
      <div className="mt-7 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/clues"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
        >
          浏览热门爆料
        </Link>
      </div>
    </div>
  );
}